// extracted by mini-css-extract-plugin
export var blockedMessage = "_82-3";
export var blockedOverlay = "_82-1";
export var fadeIn = "_82-2";
export var hereLink = "_82-0";
export var slideUp = "_82-4";